/* Base translations · Sampling and vouching — moved unchanged out of lib/i18n.js (STEP 6 · split 6f).
   Top-level keys owned by this file (no other base file and not i18n.js define them): sampling, samplingLabels, samplingMethods, vouching. */
export const I18N_BASE_SAMPLING = {
  en: {
    sampling: {
      title: "Sampling",
      subtitle: "Statistical audit sample selection",
      method: "Method",
      params: "Parameters",
      sampleName: "Sample name",
      category: "Category filter",
      confidence: "Confidence level",
      tolerable: "Tolerable misstatement / Performance Materiality",
      sampleSize: "Sample size (optional)",
      run: "Run sampling",
      existing: "Existing samples",
      selected: "Selected items",
      strata: "Strata",
      uploadHeadwiseBtn: "Upload Head-wise GL",
      headUploadsTitle: "Head-wise GL uploads",
      headCols: {
        when: "When", by: "By", mode: "Mode", fsHeads: "FS Heads",
        headName: "Head Name", input: "Input", inserted: "Inserted",
        skipped: "Skipped", pool: "Pool", replaced: "Replaced", actions: "Actions",
      },
      viewTimelineTitle: "View timeline for FS head {code}",
      livePoolTitle: "Live count of head-wise rows currently in the pool for this upload",
      allCategoriesTag: "All",
      pmReadOnly: "Performance Materiality (read-only)",
      pmHelp: "From Risk Assessment. Edit there — not here.",
      tmEditable: "Tolerable misstatement (editable)",
      tmHelp: "Defaults to Performance Materiality. Override with a reason.",
      expMisstate: "Expected misstatement",
      acceptOversize: "Accept oversize sample",
      oversizeHelp: "Allow n > 250 (no silent cap)",
      tmReason: "TM override reason (if TM ≠ PM)",
      tmReasonPh: "e.g. Sample-specific PM per ISA 530",
      sampleSizeHelp: "Leave blank for MUS to compute n from TM/EM/confidence.",
      allocMethod: "Allocation method",
      allocProportional: "Proportional (default)",
      allocNeyman: "Neyman (uses per-stratum σ)",
      allocEqual: "Equal (requires positive selection)",
      samplingSource: "Sampling source",
      sourceSelectPh: "— Select a source —",
      sourceCombined: "Combined — main GL + head-wise",
      sourceMainOnly: "Main GL only",
      sourceHeadOnly: "Head-wise only",
      sourceWorksheet: "Worksheet populations",
      sourceRequired: "Required. Choice is recorded on the working paper — pick deliberately.",
      confidenceInvalid: "Enter a confidence level between 25% and 100% (a whole number or one decimal).",   // Batch 20 · F-153
      runContinuous: "Run continuous testing",
      cols: {
        name: "Name", materialityUsed: "Materiality Used",
        population: "Population", sample: "Sample",
        uidRange: "UID Range", stats: "Stats", dedupe: "Dedupe",
      },
      reRunNeeded: "Re-run needed",
      resampleTag: "Re-sampled ·",
      populationFromTitle: "Population read from: {src}",
      mainOnly: "Main GL only",
      headOnly: "Head-wise only",
      fromRiskAssessment: "Source: 105(a)",
      intervalPrefix: "Interval:", jeFiltersUsed: "filters used", jeLines: "lines", jeVouchers: "vouchers", jeAmount: "amount total", jeNoWrite: "Nothing is saved until you click Run sampling.",
      categoryHiddenForWs: "Category filter does not apply to worksheet-sourced populations.",
      jePopulationChanged: "Population changed — reloaded the current JE population. Check the counts and run again.",
      categoryHiddenForJe: "Category filter does not apply to journal-entry populations — the J-filter population is the universe (not applied).", wsMethodBlocked: "not available for worksheet populations", wsContinuousBlocked: "not available for worksheet populations — needs GL posting dates / users", keyItems: "key items", sampledItems: "sampled",
      confPrefix: "Confidence level:",
      noHeadOverlapTitle: "No head-wise overlap — nothing superseded.",
      noneTag: "none",
      reRunToast: "Re-run",
      reRunConfirm: "Re-run \"{name}\" with the corrected fraud engine? The old sheet, its vouching items and any related discrepancies will be replaced.",
      reRunCompleteToast: "Re-run complete — {msg} created",
      reRunFailed: "Re-run failed",
      resampleBtn: "Re-sample",
      attachBtn: "Attach",
      downloadHeadCsvTitle: "Download the head-wise GL rows this sample was drawn from (CSV)",
      downloadHeadXlsxTitle: "Download the head-wise GL rows this sample was drawn from (XLSX)",
      deleteSampleConfirm: "Delete sample \"{name}\"? Its vouching items and related discrepancies will be removed too.",
      sampleDeletedToast: "Sample deleted",
      noSamplesYet: "No samples yet",
      noRowDetail: "No per-row detail captured for this upload.",
      supportingDocsFor: "Supporting documents — {name}",
      attachLabel: "Attach evidence, sample remarks or narratives",
      skippedRowsTitle: "Skipped rows",
      skippedLoading: "Loading…",
      skippedFsHeads: "FS heads:",
      skippedFixableBanner: "{n} in this list would now import cleanly. The list is a snapshot from the upload — since then you've mapped the corresponding accounts to the right FS head. Re-upload in Replace mode to pull them in.",
      replace: "Replace",
      outOfScope: "Out of scope",
      missingCode: "Missing code",
      badRow: "Bad row",
      totalSkipped: "Total skipped",
      skippedCols: {
        row: "Row #", accountCode: "Account Code", accountName: "Account Name",
        voucher: "Voucher", debit: "Debit", credit: "Credit", reason: "Reason",
      },
      openFsMappingTitle: "Open FS Mapping and jump to {code}",
      fsMappingBtn: "FS Mapping",
      fixBtn: "Fix",
      nowMappedTo: "✓ Now mapped to FS {code}",
      atUploadFs: "→ at upload: FS {code}",
      nowFs: "→ now: FS {code}",
      showingFirst: "Showing the first {n} skipped rows — {r} more were skipped but not stored to keep the audit trail bounded.",
      fixHint: "Fix hint: open {fsBold}, map the \"Account not mapped\" rows to the FS head(s) you uploaded for, then re-upload — or use {replaceBold} mode to swap the previous batch cleanly.",
      downloadCsv: "Download CSV",
      reasonLabels: {
        out_of_scope: "Mapped to a different FS head",
        unmapped_on_engagement: "Account not mapped on this engagement",
        missing_code: "No account code or name",
        bad_row: "Malformed row (couldn't parse debit/credit)",
      },
      continuousRulesTitle: "Continuous testing rules — select at least one",
      noRuleSelected: "No rule selected",
      selectedSuffix: "{rules} · {tx} flagged",
      presets: "Presets",
      noPresets: "No saved presets yet — build a rule set below and click \"Save as preset\".",
      presetTooltip: "{rules} · {scope}{threshold}",
      presetThresholdSuffix: " · threshold {n}",
      deletePresetTitle: "Delete preset",
      presetNamePh: "Preset name (e.g. Payments red-flag pack)",
      saveBtn: "Save",
      cancelBtn: "Cancel",
      saveAsPreset: "+ Save as preset",
      thresholdAmount: "Threshold amount",
      thresholdPh: "e.g. 25000",
      thresholdHelp: "Any entry with an absolute amount ≥ this value is flagged.",
      sampleScope: "Sample scope",
      combinedScope: "Combined — one sample for all selected characteristics",
      combinedHelp: "Every flagged transaction appears once; rows show every rule that triggered inclusion.",
      individualScope: "Individual — separate sample per characteristic",
      individualHelp: "Creates one vouching sheet per rule, named after the specific fingerprint / analytic.",
      populationFootnote: "Population = 100% of the current-period GL. The journal-entry rule counts (J1–J13) are those of the latest Journal Entry Testing (A9001) scan — run it first; the three Analytics counts are computed here.",
      fromSource: "From {source}",
      fraudSource: "Fraud Risk (ISA 240)",
      analyticsSource: "Analytics",
      lockedTitle: "Locked — set in 105(a) Materiality",
      notSetYet: "Not set yet",
      fromMateriality: "Source:",
      changeInRisk: "105(a)",
      source105a: "Source: 105(a)",
      editIn105a: "Edit in 105(a)",
      undoneTag: "undone",
      undoneTooltip: "Undone {when} by {who}",
      unmappedShort: "unmapped",
      dominantSkippedTitle: "{n} of {total} rows dropped because their account isn't mapped to a selected FS head — click to view",
      skippedGenericTitle: "Click to see the rows that were skipped",
      deleteHeadConfirm: "{warn}Permanent: this cannot be undone. Re-upload the file to restore it. Samples of this period will need a re-run.\n\nDelete head-wise upload?\n\n{label}",
      deleteHeadWarn: "This is a live Replace — deleting removes the snapshot too, so Undo will no longer be possible.\n\n",
      toasts: {
        deletedGl: "Deleted — {n} GL row(s) removed",
        deleteFailed: "Delete failed",
        exportFailed: "Export failed",
        pickSource: "Please select a sampling source before running.",
        pickRule: "Select at least one rule to run Continuous testing.",
        enterThreshold: "Enter a threshold amount for the 'Threshold breach' rule.",
        createdSheets: "Created {n} Continuous sheet(s)",
        sampleGenerated: "Sample generated",
        samplingFailed: "Sampling failed",
        headExportFailedShort: "Head-wise {fmt} export failed: {msg}",
        downloaded: "Downloaded {n} {units} ({fmt})",
        headExportFailed: "Head-wise {fmt} export failed",
        loadedPreset: "Loaded preset \"{name}\"",
        givePresetName: "Give the preset a name.",
        pickRuleFirst: "Select at least one rule first.",
        presetSaved: "Preset \"{name}\" saved",
        savePresetFailed: "Failed to save preset",
        deletePresetConfirm: "Delete preset \"{name}\"?",
        presetDeleted: "Preset deleted",
      },
    },
    vouching: {
      title: "Vouching Control / Summary",
      subtitle: "Overview register — test sampled items and attach supporting documents. Individual vouching sheets live inside each Head Folder.",
      voucher: "Voucher / UIN",
      uid: "Sample UID",
      tested: "Tested",
      remarks: "Remarks",
      progress: "Progress",
      exportXlsx: "Export XLSX",
      docsAttached: "Docs",
      supportDocRef: "Support doc ref",
      notDetected: "Not detected — review",
      bypassMissingDoc: "Bypass missing-doc flag",
      bypassHint: "Tick this if a remark has been filed in lieu of a supporting document.",
      backToList: "Back to all vouching sheets",
      backfillTitle: "Voucher backfill",
      backfillBodyPre: "Re-imported the GL with a proper ",
      backfillBodyMid: " column mapped? Swap the system-generated ",
      backfillBodyPost: " placeholders on every sheet in this engagement for the real numbers. running it again changes nothing.",
      backfillVoucherUin: "voucher / UIN",
      backfillBtn: "Backfill V-#### from GL",
      backfillConfirm: "Re-scan every vouching sheet on this engagement and copy real voucher numbers from the current GL onto V-#### placeholders?",
      backfilled: "Backfilled {n} placeholder(s). {left} still without a real GL voucher.",
      backfillNothing: "No placeholders swapped — {n} GL rows are still blank.",
      backfillFailed: "Backfill failed",
      loadingSheets: "Loading sheets…",
      emptyList: "No vouching sheets yet — generate a sample in the Sampling module first.",
      colName: "Sheet name",
      colMethod: "Method",
      colItems: "Items",
      colItemCompletion: "Item completion",
      colTotalPop: "Total population",
      colAmountVerified: "Amount verified",
      colPctByValue: "% verified by value",
      ofSelectedItems: "of the selected items (value tested ÷ value selected)", notProjected: "not a sample — not projected",   // Batch 14 · M1
      itemsTestedFmt: "{tested}/{total} items tested",
      byMonetary: "by monetary value",
      metricPopValueTail: "{n} value",
      metricTestedOnly: "tested rows only",
      sheetTitleFallback: "Vouching sheet",
      onThisSheet: "on this sheet",
      filterAllRows: "All rows ({n})",
      filterMissingAssertion: "Missing a specific assertion…",
      filterAnyBypass: "Any bypassed rows",
      filterNoAssertions: "Rows with zero ticks / bypasses",
      filterFullyTicked: "Rows with all 12 assertions ticked",
      whichAssertion: "Which assertion?",
      pickAssertion: "— pick assertion —",
      showingCount: "showing {shown} / {total}",
      legendNotTested: "= not tested",
      legendTested: "= tested",
      legendBypassed: "= bypassed (with remark)",
      legendIsa315: "ISA 315 (Revised) — each tick is a per-item, per-assertion deliberate action",
      loadingSheet: "Loading sheet…",
      workDone: "Work Done",
      workDoneClickHint: "click any line to edit",
      colAssertion: "Assertion",
      colProcedure: "Procedure performed",
      colLastEdited: "Last edited",
      additionalProcedures: "Additional procedures",
      addLineBtn: "Add line",
      defaultWording: "Default wording follows ISA 315 (Revised). Every edit is logged to the Audit Trail.",
      loading: "Loading…",
      balanceLevel: "Balance-level assertions",
      transactionLevel: "Transaction-level assertions",
      defaultText: "default text",
      clickToAdd: "Click to add…",
      procedurePh: "Describe the additional procedure…",
      removeLine: "Remove this line",
      bypassTemplateHint: "Templates are editable in Settings — remarks stay consistent across the team.",
      pickTemplate: "Pick a template",
      pickTemplatePh: "Choose a common rationale…",
      reasonRequired: "Reason for bypass (required)",
      reasonPh: "e.g. Not applicable — this is a reversing journal entry; tested via reconciliation of month-end balance",
      remarkRequired: "Remark is mandatory to bypass an assertion",
      tickedTitle: "Ticked — click to clear",
      tickTitle: "Tick — assertion tested",
      bypassTitle: "Bypass with remark",
      clearBypassBtn: "Clear bypass",
      cancelBtn: "Cancel",
      saveBypassBtn: "Save bypass",
      savedToast: "Saved",
      missingDocBypassed: "Missing-doc flag bypassed",
      bypassCleared: "Bypass cleared",
      noPrevRow: "No previous row with assertion ticks to copy from.",
      copiedAssertions: "Copied {n} assertion(s) from {voucher}",
      copyFailed: "Copy failed",
      saveFailed: "Save failed",
      addLineFailed: "Failed to add line",
    },
    // A2a · Sampling worksheet-population labels (EN — mirror of AR).
    // Backend server.py names count worksheets via these two keys so
    // the AR / EN screen labels stay in sync with `sampling_sources.name`.
    samplingLabels: {
      physicalCount: "Physical count — client count listing ({ref})",
      completeness: "Completeness — {ref} source documents",
      rowsUnit: "rows: {n}",
      journalEntries: "Journal entries (A9001) — {summary} · {n} {plural}",
      journalEntriesUnitOne: "entry",
      journalEntriesUnitMany: "entries",
    },
    // A2 · Sampling method labels (EN — mirror of AR at top level).
    samplingMethods: {
      Random: "Random",
      Systematic: "Systematic",
      MUS: "Monetary-unit (MUS)",
      PPS: "Probability-proportional (PPS)",
      Stratified: "Stratified",
      "Risk-Based": "Risk-based",
      Haphazard: "Haphazard",
      Continuous: "Continuous testing",
      "Specific vouching - ISA 500.A53": "Specific vouching - ISA 500.A53",
    },
  },
  ar: {
    // Round M3g · Cleanup 38 · Phase 1 — proper top-level AR blocks
    // for wt, cd, itgc, toc, a9002. Legacy AR strings for wt / cd /
    // itgc / toc are copied from the wrong-nested ar.plan.col.<…>
    // region (lines ~10012–10370, untouched per R6) so the audit
    // terms already in use are preserved. a9002 has no wrong-nested
    // AR copy so its 17 keys are freshly translated using the
    // owner-approved glossary (2026-09-30).
    samplingMethods: {
      Random: "عشوائي",
      Systematic: "منتظم",
      MUS: "العينة بوحدة النقد (MUS)",
      PPS: "العينة باحتمال متناسب مع الحجم (PPS)",
      Stratified: "طبقي",
      "Risk-Based": "على أساس المخاطر",
      Haphazard: "غير منتظم",
      Continuous: "الاختبار المستمر",
      "Specific vouching - ISA 500.A53": "Specific vouching - ISA 500.A53",
    },
    samplingLabels: {
      physicalCount: "الجرد الفعلي — قائمة جرد العميل ({ref})",
      completeness: "الاكتمال — المستندات المصدرية لـ {ref}",
      rowsUnit: "عدد الصفوف: {n}",
      journalEntries: "قيود اليومية \u2066(A9001)\u2069 — {summary} · {n} {plural}",
      journalEntriesUnitOne: "قيد",
      journalEntriesUnitMany: "قيود",
    },
    sampling: {
      title: "العينات",
      subtitle: "اختيار عينات تدقيق إحصائية",
      method: "الطريقة",
      params: "إعدادات العينة",
      sampleName: "اسم العينة",
      category: "فلتر الفئة",
      confidence: "مستوى الثقة",
      tolerable: "التحريف المقبول / الأهمية النسبية للأداء",
      sampleSize: "حجم العينة (اختياري)",
      run: "تشغيل العينة",
      existing: "العينات الحالية",
      selected: "العناصر المختارة",
      strata: "الطبقات",
      uploadHeadwiseBtn: "استيراد دفتر الأستاذ حسب رأس الحساب",
      headUploadsTitle: "استيرادات الأستاذ حسب رأس الحساب",
      headCols: {
        when: "متى", by: "بواسطة", mode: "الوضع", fsHeads: "رؤوس FS",
        headName: "اسم الرأس", input: "المدخلات", inserted: "المُدرجة",
        skipped: "المُتخطاة", pool: "المخزن", replaced: "المُستبدلة", actions: "إجراءات",
      },
      viewTimelineTitle: "عرض الخط الزمني لرأس FS {code}",
      livePoolTitle: "عدد حي للصفوف المستوردة حسب الرأس الموجودة حالياً في المخزن لهذا الاستيراد",
      allCategoriesTag: "الكل",
      pmReadOnly: "الأهمية النسبية للأداء (للقراءة فقط)",
      pmHelp: "من تقييم المخاطر. عدّلها هناك — ليس هنا.",
      tmEditable: "التحريف المقبول (قابل للتعديل)",
      tmHelp: "افتراضياً الأهمية النسبية للأداء. تجاوزها بذكر السبب.",
      expMisstate: "التحريف المتوقع",
      acceptOversize: "قبول عينة كبيرة الحجم",
      oversizeHelp: "السماح بحجم عينة أكبر من 250 (دون حد أقصى تلقائي)",
      tmReason: "سبب اختلاف التحريف المقبول عن الأهمية النسبية للأداء",
      tmReasonPh: "مثال: أهمية نسبية للأداء خاصة بالعينة وفق \u2066ISA 530 A3\u2069",
      sampleSizeHelp: "اتركه فارغًا ليُحسب حجم العينة تلقائيًا من التحريف المقبول والتحريف المتوقع ومستوى الثقة.",
      allocMethod: "طريقة التوزيع",
      allocProportional: "نسبية (افتراضية)",
      allocNeyman: "نيمان (تستخدم σ لكل طبقة)",
      allocEqual: "متساوية (تتطلب تحديداً موجباً)",
      samplingSource: "مصدر العينة",
      sourceSelectPh: "— اختر المصدر —",
      sourceCombined: "مجمّع — الأستاذ الرئيسي + حسب الرأس",
      sourceMainOnly: "الأستاذ الرئيسي فقط",
      sourceHeadOnly: "حسب الرأس فقط",
      sourceWorksheet: "مجتمعات ورقات العمل",
      sourceRequired: "مطلوب. يُسجَّل الاختيار في ورقة العمل — اختر بعناية.",
      confidenceInvalid: "أدخل مستوى ثقة بين 25% و100% (عدد صحيح أو بخانة عشرية واحدة).",   // Batch 20 · F-153
      runContinuous: "تشغيل الاختبار المستمر",
      cols: {
        name: "الاسم", materialityUsed: "الأهمية المستخدمة",
        population: "المجتمع", sample: "العينة",
        uidRange: "نطاق المعرف", stats: "إحصائيات", dedupe: "إزالة التكرار",
      },
      reRunNeeded: "إعادة التشغيل مطلوبة",
      resampleTag: "إعادة العينة ·",
      populationFromTitle: "المجتمع مقروء من: {src}",
      mainOnly: "الأستاذ الرئيسي فقط",
      headOnly: "حسب الرأس فقط",
      fromRiskAssessment: "المصدر: 105(a)",
      intervalPrefix: "الفاصل:", jeFiltersUsed: "المرشّحات المستخدمة", jeLines: "سطر", jeVouchers: "سند", jeAmount: "إجمالي المبلغ", jeNoWrite: "لا يُحفظ شيء حتى تضغط تشغيل المعاينة.",
      categoryHiddenForWs: "لا ينطبق مرشّح الفئة على مصادر أوراق العمل.",
      jePopulationChanged: "تغيّر المجتمع — أُعيد تحميل مجتمع قيود اليومية الحالي. تحقّق من الأعداد ثم شغّل مجددًا.",
      categoryHiddenForJe: "لا ينطبق مرشّح الفئة على مجتمعات قيود اليومية — مجتمع مرشّحات J هو الكل (غير مطبَّق).", wsMethodBlocked: "غير متاح لمجتمعات أوراق العمل", wsContinuousBlocked: "غير متاح لمجتمعات أوراق العمل — يحتاج تواريخ ومستخدمي قيود الأستاذ", keyItems: "بنود رئيسية", sampledItems: "مُعاينة",
      confPrefix: "مستوى الثقة:",
      noHeadOverlapTitle: "لا يوجد تداخل مع حسب الرأس — لم يُستبدل شيء.",
      noneTag: "لا شيء",
      reRunToast: "إعادة التشغيل",
      reRunConfirm: "إعادة تشغيل \"{name}\" بمحرك الاحتيال المصحح؟ ستُستبدل الورقة القديمة وبنود التدقيق والاختلافات المرتبطة.",
      reRunCompleteToast: "اكتملت إعادة التشغيل — تم إنشاء {msg}",
      reRunFailed: "فشلت إعادة التشغيل",
      resampleBtn: "إعادة العينة",
      attachBtn: "إرفاق",
      downloadHeadCsvTitle: "تنزيل صفوف الأستاذ حسب الرأس التي سُحبت منها هذه العينة (CSV)",
      downloadHeadXlsxTitle: "تنزيل صفوف الأستاذ حسب الرأس التي سُحبت منها هذه العينة (XLSX)",
      deleteSampleConfirm: "حذف العينة \"{name}\"؟ ستُحذف أيضاً بنود التدقيق والاختلافات المرتبطة.",
      sampleDeletedToast: "تم حذف العينة",
      noSamplesYet: "لا توجد عينات بعد",
      noRowDetail: "لم يتم تسجيل تفاصيل الصفوف لهذا الاستيراد.",
      supportingDocsFor: "المستندات الداعمة — {name}",
      attachLabel: "أرفق أدلة أو ملاحظات أو سرد للعينة",
      skippedRowsTitle: "الصفوف المُتخطاة",
      skippedLoading: "جاري التحميل…",
      skippedFsHeads: "رؤوس FS:",
      skippedFixableBanner: "{n} في هذه القائمة ستُستورَد الآن بشكل نظيف. القائمة لقطة من الاستيراد — منذ ذلك الحين قمت بتعيين الحسابات المقابلة لرأس FS الصحيح. أعد الاستيراد في وضع Replace لسحبها.",
      replace: "استبدال",
      outOfScope: "خارج النطاق",
      missingCode: "الرمز مفقود",
      badRow: "صف تالف",
      totalSkipped: "إجمالي المُتخطاة",
      skippedCols: {
        row: "رقم الصف", accountCode: "رمز الحساب", accountName: "اسم الحساب",
        voucher: "السند", debit: "مدين", credit: "دائن", reason: "السبب",
      },
      openFsMappingTitle: "فتح تعيين FS والانتقال إلى {code}",
      fsMappingBtn: "تعيين FS",
      fixBtn: "أصلح",
      nowMappedTo: "✓ معيَّن الآن إلى FS {code}",
      atUploadFs: "← عند الاستيراد: FS {code}",
      nowFs: "← الآن: FS {code}",
      showingFirst: "عرض أول {n} صف متخطى — تم تخطي {r} إضافية لكن لم تُخزَّن لإبقاء سجل التدقيق محدوداً.",
      fixHint: "تلميح الإصلاح: افتح {fsBold}، وعيّن صفوف \"الحساب غير معيَّن\" إلى رؤوس FS التي استوردت لها، ثم أعد الاستيراد — أو استخدم وضع {replaceBold} لاستبدال الدفعة السابقة بشكل نظيف.",
      downloadCsv: "تنزيل CSV",
      reasonLabels: {
        out_of_scope: "معيَّن إلى رأس FS مختلف",
        unmapped_on_engagement: "الحساب غير معيَّن في هذه المهمة",
        missing_code: "لا يوجد رمز أو اسم حساب",
        bad_row: "صف مشوّه (تعذر تحليل المدين/الدائن)",
      },
      continuousRulesTitle: "قواعد الاختبار المستمر — اختر قاعدة واحدة على الأقل",
      noRuleSelected: "لم تُختَر أي قاعدة",
      selectedSuffix: "{rules} · {tx} معلَّم",
      presets: "الإعدادات المسبقة",
      noPresets: "لا توجد إعدادات مسبقة محفوظة بعد — أنشئ مجموعة قواعد أدناه وانقر \"حفظ كإعداد مسبق\".",
      presetTooltip: "{rules} · {scope}{threshold}",
      presetThresholdSuffix: " · العتبة {n}",
      deletePresetTitle: "حذف الإعداد المسبق",
      presetNamePh: "اسم الإعداد المسبق (مثال: حزمة راية حمراء للمدفوعات)",
      saveBtn: "حفظ",
      cancelBtn: "إلغاء",
      saveAsPreset: "+ حفظ كإعداد مسبق",
      thresholdAmount: "مبلغ العتبة",
      thresholdPh: "مثال: 25000",
      thresholdHelp: "أي قيد بمبلغ مطلق ≥ هذه القيمة يُعلَّم.",
      sampleScope: "نطاق العينة",
      combinedScope: "مجمّعة — عينة واحدة لجميع الخصائص المختارة",
      combinedHelp: "تظهر كل معاملة معلَّمة مرة واحدة؛ تعرض الصفوف كل قاعدة أدّت للتضمين.",
      individualScope: "فردية — عينة منفصلة لكل خاصية",
      individualHelp: "تنشئ ورقة تدقيق واحدة لكل قاعدة، مسمّاة باسم البصمة / التحليل المحدد.",
      populationFootnote: "المجتمع = 100% من أستاذ الفترة الحالية. تُسحب الأعداد مباشرة من تقييم المخاطر ← مخاطر الاحتيال \u2066(ISA 240)\u2069 والتحليلات — لا يعيد هذا اللوح المسح، فأي تغيير هناك ينساب مباشرة إلى كل تشغيل مستمر.",
      fromSource: "من {source}",
      fraudSource: "مخاطر الاحتيال \u2066(ISA 240)\u2069",
      analyticsSource: "التحليلات",
      lockedTitle: "مقفل — يُحدَّد في نموذج 105(a) الأهمية النسبية",
      notSetYet: "غير محدد بعد",
      fromMateriality: "المصدر:",
      changeInRisk: "105(a)",
      source105a: "المصدر: 105(a)",
      editIn105a: "التعديل في 105(a)",
      undoneTag: "تراجَع",
      undoneTooltip: "تراجَع {when} بواسطة {who}",
      unmappedShort: "غير معيَّن",
      dominantSkippedTitle: "{n} من أصل {total} صف أُسقطت لأن حسابها غير معيَّن لرأس FS مختار — انقر للعرض",
      skippedGenericTitle: "انقر لعرض الصفوف التي تم تخطيها",
      deleteHeadConfirm: "{warn}حذف نهائي: لا يمكن التراجع عنه. أعد رفع الملف لاستعادته. عينات هذه الفترة ستحتاج إلى إعادة تشغيل.\n\nحذف الاستيراد حسب الرأس؟\n\n{label}",
      deleteHeadWarn: "هذا استبدال حي — الحذف يزيل اللقطة أيضاً، لذا لن يكون التراجع ممكناً.\n\n",
      toasts: {
        deletedGl: "تم الحذف — تمت إزالة {n} صف(وف) من الأستاذ",
        deleteFailed: "فشل الحذف",
        exportFailed: "فشل التصدير",
        pickSource: "اختر مصدر عينة قبل التشغيل من فضلك.",
        pickRule: "اختر قاعدة واحدة على الأقل لتشغيل الاختبار المستمر.",
        enterThreshold: "أدخل مبلغ عتبة لقاعدة 'Threshold breach'.",
        createdSheets: "تم إنشاء {n} ورقة اختبار مستمر",
        sampleGenerated: "تم توليد العينة",
        samplingFailed: "فشلت العينة",
        headExportFailedShort: "فشل تصدير حسب الرأس {fmt}: {msg}",
        downloaded: "تم تنزيل {n} {units} ({fmt})",
        headExportFailed: "فشل تصدير حسب الرأس {fmt}",
        loadedPreset: "تم تحميل الإعداد المسبق \"{name}\"",
        givePresetName: "أعطِ الإعداد المسبق اسماً.",
        pickRuleFirst: "اختر قاعدة واحدة على الأقل أولاً.",
        presetSaved: "تم حفظ الإعداد المسبق \"{name}\"",
        savePresetFailed: "فشل حفظ الإعداد المسبق",
        deletePresetConfirm: "حذف الإعداد المسبق \"{name}\"؟",
        presetDeleted: "تم حذف الإعداد المسبق",
      },
    },
    vouching: {
      title: "مطابقة السندات / الملخص",
      subtitle: "سجل نظرة عامة — اختبر العناصر المختارة وأرفق المستندات. توجد أوراق التدقيق الفردية داخل كل مجلد رئيسي.",
      voucher: "السند",
      uid: "رقم العينة",
      tested: "تم الاختبار",
      remarks: "ملاحظات",
      progress: "التقدم",
      exportXlsx: "تصدير XLSX",
      docsAttached: "المستندات",
      supportDocRef: "مرجع المستند",
      notDetected: "غير مكتشف — مراجعة",
      bypassMissingDoc: "تجاوز إشارة نقص المستند",
      bypassHint: "حدد هذا الخيار إذا تم تسجيل ملاحظة بدلاً من المستند الداعم.",
      backToList: "العودة إلى جميع أوراق التحقق",
      backfillTitle: "استرداد أرقام السندات",
      backfillBodyPre: "هل أعدت استيراد الأستاذ العام مع عمود ",
      backfillBodyMid: " مُعيّن بشكل صحيح؟ استبدل العناصر النائبة المُنشأة آليًا ",
      backfillBodyPost: " على كل ورقة في هذه المهمة بالأرقام الحقيقية. آمن وقابل لإعادة التشغيل.",
      backfillVoucherUin: "السند / UIN",
      backfillBtn: "استرداد V-#### من الأستاذ العام",
      backfillConfirm: "إعادة فحص كل ورقة تحقق في هذه المهمة ونسخ أرقام السندات الحقيقية من الأستاذ العام الحالي إلى العناصر النائبة V-####؟",
      backfilled: "تم استرداد {n} عنصر نائب. {left} لا يزال بدون رقم سند حقيقي.",
      backfillNothing: "لم يتم استبدال أي عناصر نائبة — {n} صف في الأستاذ العام لا يزال فارغًا.",
      backfillFailed: "فشل الاسترداد",
      loadingSheets: "جاري تحميل الأوراق…",
      emptyList: "لا توجد أوراق تحقق بعد — قم بإنشاء عينة في وحدة المعاينة أولاً.",
      colName: "اسم الورقة",
      colMethod: "الطريقة",
      colItems: "العناصر",
      colItemCompletion: "إكمال العناصر",
      colTotalPop: "إجمالي المجتمع",
      colAmountVerified: "المبلغ الذي تم التحقق منه",
      colPctByValue: "% التحقق حسب القيمة",
      ofSelectedItems: "من البنود المختارة (القيمة المختبرة ÷ القيمة المختارة)", notProjected: "ليست عينة — لا تُسقَط",   // Batch 14 · M1
      itemsTestedFmt: "{tested}/{total} عنصرًا تم اختباره",
      byMonetary: "حسب القيمة النقدية",
      metricPopValueTail: "قيمة {n}",
      metricTestedOnly: "الصفوف المختبرة فقط",
      sheetTitleFallback: "ورقة تحقق",
      onThisSheet: "في هذه الورقة",
      filterAllRows: "كل الصفوف ({n})",
      filterMissingAssertion: "تفتقد إلى تأكيد محدد…",
      filterAnyBypass: "أي صفوف تم تجاوزها",
      filterNoAssertions: "صفوف بلا علامات / تجاوزات",
      filterFullyTicked: "صفوف مع 12 تأكيدًا مُعلَّمًا",
      whichAssertion: "أي تأكيد؟",
      pickAssertion: "— اختر تأكيدًا —",
      showingCount: "عرض {shown} / {total}",
      legendNotTested: "= لم يُختبر",
      legendTested: "= مُختبر",
      legendBypassed: "= تم التجاوز (مع ملاحظة)",
      legendIsa315: "ISA 315 (المُعدَّل) — كل علامة هي إجراء متعمد لكل عنصر ولكل تأكيد",
      loadingSheet: "جاري تحميل الورقة…",
      workDone: "العمل المُنجز",
      workDoneClickHint: "انقر على أي سطر لتعديله",
      colAssertion: "التأكيد",
      colProcedure: "الإجراء المُنفَّذ",
      colLastEdited: "آخر تعديل",
      additionalProcedures: "إجراءات إضافية",
      addLineBtn: "إضافة سطر",
      defaultWording: "الصياغة الافتراضية تتبع ISA 315 (المُعدَّل). يُسجَّل كل تعديل في سجل المراجعة.",
      loading: "جاري التحميل…",
      balanceLevel: "تأكيدات على مستوى الرصيد",
      transactionLevel: "تأكيدات على مستوى المعاملة",
      defaultText: "نص افتراضي",
      clickToAdd: "انقر للإضافة…",
      procedurePh: "صف الإجراء الإضافي…",
      removeLine: "حذف هذا السطر",
      bypassTemplateHint: "القوالب قابلة للتعديل في الإعدادات — تبقى الملاحظات متسقة عبر الفريق.",
      pickTemplate: "اختر قالبًا",
      pickTemplatePh: "اختر مبررًا شائعًا…",
      reasonRequired: "سبب التجاوز (مطلوب)",
      reasonPh: "مثال: غير قابل للتطبيق — هذا قيد عكسي؛ تم اختباره عبر تسوية رصيد نهاية الشهر",
      remarkRequired: "الملاحظة إلزامية لتجاوز التأكيد",
      tickedTitle: "مُعلَّم — انقر للإلغاء",
      tickTitle: "علِّم — التأكيد مُختبَر",
      bypassTitle: "تجاوز مع ملاحظة",
      clearBypassBtn: "إلغاء التجاوز",
      cancelBtn: "إلغاء",
      saveBypassBtn: "حفظ التجاوز",
      savedToast: "تم الحفظ",
      missingDocBypassed: "تم تجاوز علامة المستند الناقص",
      bypassCleared: "تم إلغاء التجاوز",
      noPrevRow: "لا يوجد صف سابق فيه علامات تأكيد للنسخ منه.",
      copiedAssertions: "تم نسخ {n} تأكيد من {voucher}",
      copyFailed: "فشل النسخ",
      saveFailed: "فشل الحفظ",
      addLineFailed: "فشل إضافة السطر",
    },
  },
};

export default I18N_BASE_SAMPLING;
